import { ExpertiseItemProps } from './interface/interface';

export const expertiseDetailData = {
  paragraphs: [
    'In today’s digital-first economy, every business is exposed to cyber risks. From data breaches and ransomware attacks to online fraud and privacy violations, cyber threats can disrupt operations and cause legal issues. Cyber Law provides the framework to ensure compliance, secure transactions, and protect sensitive data.',
    'Legalligence combines legal expertise with AI tools to help businesses meet compliance, draft strong digital policies, and stay ahead of cyber threats. Whether a startup or enterprise, we build cyber law strategies that are smart, scalable, and resilient.',
  ],
  image: '../assets/images/expertise-image.jpg',
};

export const customsLawData = {
  paragraphs: [
    'Customs Law governs the import and export of goods, covering tariffs, duties, classifications, and compliance with trade policies. For global businesses, navigating these rules is essential to avoid delays, penalties, and legal risks in an increasingly regulated trade environment.',
    'Legalligence offers expert Customs Law services led by a consultant with 20+ years of experience. From classification and valuation to dispute resolution and full compliance support, we help businesses streamline cross-border trade and minimize regulatory risk.',
  ],
  image: '../assets/images/Custom-law.png',
};

export const goodsAndServicesData = {
  paragraphs: [
    'Goods and Services Tax (GST) is central to India’s indirect tax system, affecting every stage of the supply chain. Managing GST compliance is crucial, as errors in classification, invoicing, or filings can lead to penalties and legal issues amid evolving laws.',
    'At Legalligence, our expert team with 20+ years of experience offers specialized GST advisory, compliance support, and litigation management. We help businesses navigate complex regulations, optimize tax credits, and ensure accurate filings with a tech-driven, clear approach. ',
  ],
  image: '../assets/images/GoodsAndServices.png',
};
export const corporateLawData = {
  paragraphs: [
    'Corporate Law governs the formation, management, and operations of businesses—covering everything from company incorporation and governance to mergers, acquisitions, contracts, and regulatory compliance. Corporate law helps startups and enterprises operate legally and minimize risks.',
    'At Legalligence, we provide end-to-end corporate legal support tailored to your business goals. With a tech-enabled, precision-driven approach, we help companies make confident decisions, avoid legal pitfalls, and stay focused on growth—while we handle the legal groundwork.',
  ],
  image: '../assets/images/corporateLaw.png',
};
export const expertiseListingData: ExpertiseItemProps[] = [
  {
    title: 'Advisory & Strategic Planning',
    description:
      'We provide strategic counsel on lawful dataset sourcing, token offerings, fintech integrations, AI liability, cross-border data flows, and global regulatory compliance.',
  },
  {
    title: 'Intellectual Property',
    description:
      "We protect our clients' innovations through comprehensive IP strategies, including securing patents, trademarks, and copyrights for Al products.",
  },
  {
    title: 'Dispute Resolution',
    description:
      'Our team offers litigation back-end support and defends clients in regulatory inquiries and enforcement actions across all digital sectors. ',
  },
  {
    title: 'Smart Legal Drafting',
    description:
      'We use AI-powered tools to draft data-driven documents like AI and SaaS contracts, website terms, privacy policies, and complex vendor or crypto exchange agreements.',
  },
  {
    title: 'Compliance Management',
    description:
      'We ensure AML/KYC compliance for crypto, support adherence to AI, data and IT laws, and specialize in healthcare data compliance, including HIPAA and global standards.',
  },
];

export const customListingData: ExpertiseItemProps[] = [
  {
    title: 'Compliance and Regulatory Support ',
    description:
      'We perform compliance health checks under Customs and allied laws, assist with AEO Scheme applications, and provide support for FTA and Rules of Origin requirements.',
  },
  {
    title: 'Trade Remedies',
    description:
      'We offer comprehensive trade remedies support, including advisory, petition filing, response to anti-dumping and countervailing duty measures, handling notifications, and pursuing writs to counter unfair trade practices.',
  },
  {
    title: 'Dispute Resolution & Litigation',
    description:
      'We provide comprehensive litigation support from SCN stage through all appeals, including CESTAT, High Courts, and Supreme Court. We also cover DRI investigations and international trade dispute representation.',
  },
  {
    title: 'Trade Policy and Strategy',
    description:
      'We deliver strategic advice on Foreign Trade Policy, help optimize supply chains using SEZ and FTWZ frameworks, and provide expert counsel on WTO obligations to reduce trade barriers.',
  },
  {
    title: 'Customs Advisory & Planning',
    description:
      'We provide support on HSN product classification, customs valuation including SVB investigations, and advisory on SCOMET compliance and export restrictions.',
  },
];
export const goodsAndServiceListingData: ExpertiseItemProps[] = [
  {
    title: 'Compliance & Advisory',
    description:
      'Our services include conducting GST compliance audits, advising on the classification and valuation of goods and services, and offering expert guidance on input tax credit (ITC) eligibility.',
  },
  {
    title: 'Litigation and Dispute Management',
    description:
      'We provide complete litigation support-from drafting replies and representation in adjudications to handling appeals before all appellate authorities, including the Supreme Court.',
  },
  {
    title: 'Transaction Support and Structuring ',
    description:
      'We conduct indirect tax due diligence, review business models to identify GST optimization opportunities, and provide advisory on tax-efficient transaction structuring.',
  },
  {
    title: 'Training and Awareness Programs ',
    description:
      'We deliver customized GST training workshops and awareness programs on recent amendments to help businesses enhance internal compliance capabilities.',
  },
  {
    title: 'Investigations and Enforcement ',
    description:
      'We assist clients in managing departmental inquiries, responding to summonses from GST authorities, and mitigating risks during enforcement actions such as searches and seizures.',
  },
];
export const corporateLawListingData: ExpertiseItemProps[] = [
  {
    title: 'Corporate Structuring and Governance',
    description:
      'We assist with entity structuring, incorporation, and establishing strong corporate governance frameworks.',
  },
  {
    title: 'Commercial Contracts',
    description:
      'We handle the drafting & negotiation of commercial contracts & essential board resolutions.',
  },
  {
    title: 'Regulatory Compliance',
    description:
      'We ensure your compliance with key regulations under the Companies Act, SEBI, and FEMA',
  },
  {
    title: 'Corporate Transactions',
    description:
      'Our expertise covers complex transactions including mergers & acquisitions (M&A), joint ventures, and strategic alliances.',
  },
  {
    title: 'International Business',
    description: 'We provide advisory on cross-border transactions and foreign investment.',
  },
];
